export default [
  {
    path:'/admin/coupon/list',
    name:'coupon_list',
    component:()=>import('@/views/coupon/list'),
    meta:{
      title:'优惠券'
    }
  },
  {
    path:'/admin/coupon/code_list',
    name:'CouponCodeList',
    component:()=>import('@/views/coupon/coupon_code'),
    meta:{
      title:'兑换码列表'
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/coupon.js